<template>
  <div class="top-box">
    <i
      v-if="!isCollapse"
      class="el-icon-s-fold top-box-i"
      @click="changeCollapse"
    ></i>
    <i
      v-if="isCollapse"
      class="el-icon-s-unfold top-box-i"
      @click="changeCollapse"
    ></i>
    <div style="display:flex;width:140px;margin-left: 20px;">
      <el-tooltip class="item" effect="dark" content="全屏显示" placement="top-start">
            <i class="el-icon-s-platform" style="font-size: 23px;flex: 1;" @click="screen"></i>
      </el-tooltip>
  <!--    <el-tooltip class="item" effect="dark" content="链接" placement="top-start">
            <i type="primary" class="el-icon-share" style="font-size: 23px;flex: 1;"></i>
      </el-tooltip> -->
      <!-- <el-tooltip class="item" effect="dark" content="刷新" placement="top-start" >
           <i class="el-icon-refresh" style="font-size: 23px;flex: 1;" @click="shuaxin"></i>
      </el-tooltip> -->
    </div>
    <div style="flex: 1; margin-right: 10px">
      <div style="display: flex; float: right">
        <img
          src="../../../public/img/default_face.png"
          style="margin-top: 15px; width: 32px; height: 32px"
        />
        <span
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 60px;
            color: #000000;
            margin: 0 20px 0 5px;
          "
          >商户: {{ yxLoginPhone || '未登录' }}</span>
        <el-tooltip v-if="yxLoginPhone" effect="dark" content="退出系统" placement="bottom">
          <div>
            <i
              class="el-icon-switch-button"
              style="color: #000000; font-size: 18px; margin-top: 20px"
              @click="logout"
            ></i>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
  import {removeStore} from '../../util/store.js'
  import { gelogout } from '../../../config/api';
export default {
  data() {
    return {
			yxLoginPhone: '',
      isCollapse: false,
      active: '',
      fullscreen: false
    };
  },
  mounted() {
    let that = this;
    setInterval(function () {
      // 定位当前菜单
      that.active = that.$router.currentRoute.path;
    }, 500);
		
		this.yxLoginPhone = window.sessionStorage.getItem('yxLoginPhone');
  },
  methods: {
    // 全屏按钮
    screen() {
       let element = document.documentElement;
       if (this.fullscreen) {
        if (document.exitFullscreen) {
         document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
         document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
         document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
         document.msExitFullscreen();
        }
       } else {
        if (element.requestFullscreen) {
         element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
         element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
         element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
         // IE11
         element.msRequestFullscreen();
        }
       }
       this.fullscreen = !this.fullscreen;
      },
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
      this.$emit('changeCollapse');
    },
    logout() {
      this.$confirm('退出系统, 是否继续?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 退出操作，todo
        gelogout().then(res =>{
          if(res.data.state == 0){
            this.$router.push({ path: '/login' });
            console.log(res)
						
						window.sessionStorage.removeItem('yxLoginPhone');
          }else{
            this.$message(res.data.msg)
          }
        })
        //this.$router.push({ path: '/login' });
      });
    }
  }
};
</script>

<style>
.top-box {
  height: 60px;
  display: flex;
  background-color: #ffffff;
  border-bottom: 1px solid #eeeeee;
  align-content: center;
  align-items: center;
}
.top-box-i {
  width: 32px;
  font-size: 24px;
  margin: 0px 10px 0 15px;
  color: #000000;
}
.el-menu--horizontal .el-menu--popup .el-submenu__title {
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/page/top/index.vue